export default "/images/icons8-italy.png?143de03c7da6c391273ff09c727b2f66";